
  // Use strict
  'use strict'

  import '../sass/_fibernest.scss';
import Offer from './app/Offer.js';

  // import 'ion-rangeslider/css/ion.rangeSlider.css';

  // import 'jquery-cookiebar/jquery.cookiebar.css';

  window.$ = window.jQuery = require('jquery');

  window.jQuery = window.$;

  window.ionRangeSlider = require('ion-rangeslider');

  require('jquery.countdown');

  require('bootstrap-sass');

  require('bootstrap-sass-datepicker');

  window.cookieBar = require('./jquery.cookiebar.js');

  window.ProgressBar = require('./progressbar.min');

  window.accounting = require('accounting-js');

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // The application JavaScript object
  window.APPLICATION =
  {

    // The path prefix
    _PATH_PREFIX: '',

    // The data prefix
    _DATA_PREFIX: '',

    // The password version
    _PASSWORD_VERSION: '1.0.0',

    // Initialize any relevant scripts
    _init: function (controller, action)
    {
      window.$('.datepicker').datepicker({
        format: 'dd-mm-yyyy',
        startDate: '+1d',
        todayHighlight: true,
        templates: {
          leftArrow: '<i class="fa fa-long-arrow-left"></i>',
          rightArrow: '<i class="fa fa-long-arrow-right"></i>'
        }
      });
      // If there are application-wide scripts to initialize
      if (undefined !== this._APPLICATION && 'function' === typeof this._APPLICATION._init)
      {
        this._APPLICATION._init(controller, action)
      }

      // If the controller is defined
      if (undefined !== this[controller])
      {

        // If there are controller-wide scripts to initialize
        if ('function' === typeof this[controller]._init)
        {
          this[controller]._init()
        }

        // If there are action-wide scripts to initialize
        if (undefined !== this[controller][action] && 'function' === typeof this[controller][action]._init)
        {
          this[controller][action]._init()
        }

      }

    },

    // Application-wide scripts
    _APPLICATION: require('./app/_APPLICATION'),

    // Global frontend functionality
    Global: require('./app/_global'),

    // Install scripts
    _Install: require('./app/_Install'),

    // Sign up scripts
    SignUp: require('./app/SignUp'),

    // Password scripts
    Password: require('./app/Password'),

    // Calendar scripts
    Calendar: require('./app/Calendar'),

    // Account scripts
    Account: require('./app/Account'),

    // Homepage Scripts
    Home: require('./app/Home'),

    // Dashboard scripts
    Dashboard: require('./app/Dashboard'),

    // Modals scripts
    Modals: require('./app/Modals'),

    // Mifi scripts
    Mifi: require('./app/Mifi'),

    // Vulnerability scripts
    Vulnerability: require('./app/Vulnerability'),

    FibreNode: require('./app/FibreNode'),

    NodeConfigurator: require('./app/NodeConfigurator'),
    PodConfigurator: require('./app/PodConfigurator'),
    Vonage: require('./app/Vonage'),

    SocialTariff: require('./app/SocialTariff'),
    WifiGuarantee: require('./app/WiFiGuarantee'),

    Offer: require('./app/Offer'),

    OneTouchSwitching: require('./app/OneTouchSwitching'),

    Coupons: require('./app/Coupons'),

    Broadband: require('./app/Broadband'),
  }

  APPLICATION.Global.init()

  document.body.classList.add('ready')
